import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useLang } from '@/shared/i18n/useT';
import { InlineSVG } from './InlineSVG';
import { HashLink } from './HashLink';

export function Nav() {
  const { t, lang, setLang } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const langLabel = lang === 'en' ? 'Language' : 'Idioma';

  return (
    <nav className={`bp-nav ${scrolled ? 'is-scrolled' : ''} ${open ? 'is-open' : ''}`}>
      <Link className="brand" to="/" aria-label="Bundleport">
        <InlineSVG
          src="/assets/logo-bundleport.svg"
          alt="Bundleport"
          style={{ display: 'block', width: 156 }}
        />
      </Link>
      <button
        className="bp-nav-toggle"
        aria-label="Menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <span />
        <span />
        <span />
      </button>
      <div className="bp-nav-links">
        <NavLink
          className={({ isActive }) => `nav-link${isActive ? ' is-active' : ''}`}
          to="/about"
          end
        >
          {t.nav.about}
        </NavLink>
        <NavLink
          className={({ isActive }) => `nav-link${isActive ? ' is-active' : ''}`}
          to="/api-platform"
          end
        >
          {t.nav.apiPlatform}
        </NavLink>
        <a
          className="nav-link"
          href="https://app.bundleport.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t.nav.login}
        </a>
        <div className="bp-lang" role="group" aria-label={langLabel}>
          <button
            type="button"
            className={lang === 'es' ? 'on' : ''}
            aria-pressed={lang === 'es'}
            aria-label={lang === 'en' ? 'Switch to Spanish' : 'Cambiar a español'}
            onClick={() => setLang('es')}
          >
            ES
          </button>
          <span className="bp-lang-sep" aria-hidden="true">
            /
          </span>
          <button
            type="button"
            className={lang === 'en' ? 'on' : ''}
            aria-pressed={lang === 'en'}
            aria-label={lang === 'en' ? 'Switch to English' : 'Cambiar a inglés'}
            onClick={() => setLang('en')}
          >
            EN
          </button>
        </div>
        <HashLink to="contacto" className="cta" onClick={() => setOpen(false)}>
          {t.nav.cta}
        </HashLink>
      </div>
    </nav>
  );
}
